var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background":"rgb(242, 243, 248)"},attrs:{"id":"app"}},[(_vm.me.id)?_c('SystemAppBar'):_vm._e(),(_vm.me.id)?_c('SystemNavigation'):_vm._e(),_c('v-main',[_c('Toast'),_c('ModalChangePassword'),_c('router-view')],1),(_vm.me.id)?_c('navigation-notify'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }